<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="product.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
                @blur="$emit('on-name-change', product.name)"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="description">Description</label>
            <textarea
                id="description"
                v-model="product.description"
                type="text"
                class="form-control rtl"
                :class="{
                    'is-invalid': hasError('description')
                }"
                dir="auto"
                rows="4"
                placeholder="Description"
            />
            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="price">Price</label>
            <currency-input
                id="price"
                v-model="product.price"
                class="form-control"
                :class="{
                    'is-invalid': hasError('price')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('price') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label>
                Gallery
            </label>
            <media-chooser v-model="product.gallery" type="image" multiple />
        </div>

        <div class="form-group col-12">
            <label for="supplier">Supplier</label>
            <v-select
                v-model="product.supplierId"
                label="name"
                :reduce="supplier => supplier.id"
                :options="suppliers"
                placeholder="Search..."
                :class="{
                    'is-invalid': hasError('supplierId')
                }"
                @search="onSupplierSearch"
            >
                <template slot="no-options">
                    No result
                </template>
            </v-select>

            <div class="invalid-feedback">
                {{ getError('supplierId') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label>Only for Aguda members?</label>
            <b-form-checkbox v-model="product.onlyForAgudaMembers" switch />
        </div>

        <template v-if="!product.onlyForAgudaMembers">
            <div class="form-group col-12">
                <label>Add another price for Aguda members</label>
                <b-form-checkbox v-model="isAgudaPriceEnabled" switch />
            </div>
            <div v-if="isAgudaPriceEnabled" class="form-group col-12">
                <label for="agudaPrice">Aguda members price</label>
                <currency-input
                    id="agudaPrice"
                    v-model="product.agudaPrice"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('agudaPrice')
                    }"
                />
                <div class="invalid-feedback">
                    {{ getError('agudaPrice') }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import CurrencyInput from '@/components/elements/CurrencyInput';

export default {
    components: {
        CurrencyInput
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            product: {},
            suppliers: [],

            isAgudaPriceEnabled: false
        };
    },

    watch: {
        product() {
            this.$emit('input', this.product);
        },

        isAgudaPriceEnabled(value) {
            this.product.agudaPrice = value
                ? this.product.agudaPrice || 0
                : null;
        }
    },

    async created() {
        this.product = { ...this.value };
        this.isAgudaPriceEnabled = this.editMode
            ? this.product.agudaPrice !== null
            : false;

        try {
            const { rows: suppliers } = await this.getSuppliers({
                perPage: 100
            });

            this.suppliers = suppliers;
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getSuppliers: 'suppliers/index'
        }),

        async onSupplierSearch(search, loading) {
            loading(true);

            try {
                const { rows: suppliers } = await this.getSuppliers({
                    search,
                    perPage: 100
                });

                this.suppliers = suppliers;
            } catch (error) {
                console.error(error);

                this.$toasterError();
            } finally {
                loading(false);
            }
        },

        hasError(key) {
            return (
                this.validation.product[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.product,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
